import {KecPath, Service, Version, source} from './constants';

// 预留实例券列表
export const describeResProduct = {
    basePath: KecPath,
    method: 'post',
    params: {
        Action: 'DescribeResProduct',
        Service,
        Version,
        source
    }
};
